import React from 'react';
import { paraQuem, siteConfig } from '../../data/mock';
import { MessageCircle, ArrowRight } from 'lucide-react';

const ParaQuemSection = () => {
  const whatsappLink = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(siteConfig.whatsappMessage)}`;

  // Split items into two columns
  const leftItems = paraQuem.items.slice(0, 3);
  const rightItems = paraQuem.items.slice(3, 6);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        {/* Section Header - Centered */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-serif text-neutral-900 mb-4">
            <span className="text-[#c9a962]">Para quem</span> é essa página
          </h2>
          <p className="text-neutral-600 text-xl">
            {paraQuem.subtitle}
          </p>
        </div>
        
        {/* Two Column List - Equal Height */}
        <div className="grid md:grid-cols-2 gap-4 mb-12">
          {/* Left Column */}
          <div className="space-y-4">
            {leftItems.map((item, index) =>
            <div
              key={index}
              className="flex items-start border border-emerald-200 min-h-[88px] !py-[31px] !px-[20px] !gap-[16px] rounded-xl bg-emerald-50">

                <div className="w-6 h-6 bg-emerald-100 border border-emerald-300 rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg className="w-4 h-4 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-neutral-700 leading-relaxed">{item}</span>
              </div>
            )}
          </div>
          
          {/* Right Column */}
          <div className="space-y-4">
            {rightItems.map((item, index) =>
            <div
              key={index}
              className="flex items-start gap-4 p-5 bg-emerald-50 border border-emerald-200 rounded-xl min-h-[88px]">

                <div className="w-6 h-6 bg-emerald-100 border border-emerald-300 rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg className="w-4 h-4 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-neutral-700 leading-relaxed">{item}</span>
              </div>
            )}
          </div>
        </div>
        
        {/* Quote and CTA */}
        <div className="text-center">
          <p className="text-neutral-600 text-xl italic mb-8 max-w-2xl mx-auto">
            "Nosso compromisso é proteger seu patrimônio e garantir seus direitos com estratégia e eficiência."
          </p>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-3 bg-emerald-600 hover:bg-emerald-500 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-emerald-500/25">

            <MessageCircle className="w-5 h-5" />
            {siteConfig.ctaText}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>);

};

export default ParaQuemSection;